// 注册组件

// 字典标签组件
import DictTag from './DictTag'

// 分页组件
import Pagination from "./Pagination";

// 编辑器
import MonacoEditor from '@/components/Editor/monacoEditor.vue';
import monacoEditorDialog from '@/components/Editor/monacoEditorDialog.vue';

import './Draggable/draggable-resizable.css';
import DraggableResizable from './Draggable/draggable-resizable';

import Version from './Form/Version';
import ImageView from './Form/ImageView';
import FormTitle from './Form/FormTitle';
import CollapseBar from './Form/CollapseBar';

import FunnelInputSelect from './Selector/funnel-input-select';
import FunnelMultiSelect from './Selector/funnel-multi-select';
import FunnelSingleSelect from './Selector/funnel-single-select';
import FunnelRemoteSelect from './Selector/funnel-remote-select';

import SelectorRemote from './Selector/selector-remote';
import SelectorKeyValue from './Selector/selector-key-value';

import DynamicTable from './Table/DynamicTable';
import SortableIcon from './Table/SortableIcon';

function install (Vue) {
  if (install.installed) return
  install.installed = true
  Vue.component('DictTag', DictTag)
  Vue.component('Pagination', Pagination)

  console.log("-----注册了组件：编辑器----");
  Vue.component('MonacoEditor', MonacoEditor);
  Vue.component('monacoEditorDialog', monacoEditorDialog);

  console.log("-----注册了组件：Drag组件----");
  Vue.component('DraggableResizable', DraggableResizable);

  console.log("-----注册了组件：Form类组件----");
  Vue.component('SelectorRemote', SelectorRemote);
  Vue.component('SelectorKeyValue', SelectorKeyValue);
  Vue.component('Version', Version);
  Vue.component('FormTitle', FormTitle);
  Vue.component('ImageView', ImageView);
  Vue.component('CollapseBar', CollapseBar);

  console.log("-----注册了组件：动态Table组件----");
  Vue.component('DynamicTable', DynamicTable);
  Vue.component('FunnelRemoteSelect', FunnelRemoteSelect);
  Vue.component('FunnelInputSelect', FunnelInputSelect);
  Vue.component('FunnelMultiSelect', FunnelMultiSelect);
  Vue.component('FunnelSingleSelect', FunnelSingleSelect);
  Vue.component('SortableIcon', SortableIcon);
}

export default install
